import { AdAnalyticsFilter } from '@kaizenplatform/hugot-entity';
import { createElement, FC, useContext } from 'react';

import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import Page from '../page/ShowAdAnalyticsPage';

const AdAnalyticsDetailPage: FC = () => {
  const dependency = useContext(DependencyContext);
  const state = useContext(StateContext);

  return (
    <Page
      loading={state.adAnalyticsVideos.fetching >= 1 || state.adAnalyticsPlacementTypes.fetching >= 1}
      language={state.language}
      submitReport={state.adAnalyticsVideos.submitReport}
      checkSubmitReport={() => {
        dependency.showAdAnalyticsVideoUsecase.checkSubmitReport();
      }}
      analyticsVideos={state.adAnalyticsVideos.items}
      // dailyPerformance={state.adAnalyticsVideos.dailyPerformances}
      placementTypes={state.adAnalyticsPlacementTypes.placementTypes}
      selectedPlacementTypes={state.adAnalyticsPlacementTypes.selectedPlacementTypes}
      tryCreateReport={({ title }: { title: string }) => {
        dependency.showAdAnalyticsVideoUsecase.tryCreateReport({
          title,
        });
      }}
      onUpdatePlacementTypes={({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => {
        dependency.showAdAnalyticsVideoUsecase.updatePlacementTypes({ platformKey, mediaKey, placementKey, period });
      }}
      onSubmitPlacementTypes={() => {
        dependency.showAdAnalyticsVideoUsecase.submitPlacementTypes();
      }}
      onBackListPage={() => {
        dependency.showAdAnalyticsVideoUsecase.backListPage();
      }}
      onMount={() => {
        dependency.authenticationUsecase.needSignedIn();
        dependency.showAdAnalyticsVideoUsecase.prepare();
      }}
      onUnmount={() => {
        dependency.showAdAnalyticsVideoUsecase.dispose();
      }}
    />
  );
};

export default AdAnalyticsDetailPage;
